import { css } from 'aphrodite';
import React from 'react';
import { TextInputFormField } from '../../../../../../components/TextInputFormField';
import { FormFieldErrorMessage } from '../index';
import { styleSheet } from '../styles';

interface FieldInputProps {
	fieldId: string;
	questionIndex: number;
	value: string;
	placeholder: string;
	disabled: boolean;
	onChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
	errorMessage?: string;
}

export const FieldInput = React.memo<FieldInputProps>(
	({ fieldId, questionIndex, value, placeholder, disabled, onChange, errorMessage }) => {
		// Memoize expensive calculations
		const inputId = React.useMemo(
			() => `edit-custom-${fieldId}-question-${questionIndex}-input`,
			[fieldId, questionIndex]
		);

		const displayPlaceholder = React.useMemo(() => placeholder || 'Untitled Question', [placeholder]);

		const wrapperKey = React.useMemo(() => `${fieldId}-question-${questionIndex}`, [fieldId, questionIndex]);

		// Memoize change handler
		const handleChange = React.useCallback(
			(e: React.ChangeEvent<HTMLInputElement>) => {
				if (onChange) {
					onChange(e, questionIndex);
				}
			},
			[onChange, questionIndex]
		);

		return (
			<div className={css(styleSheet.questionWrap)} key={wrapperKey}>
				<TextInputFormField
					placeholder={displayPlaceholder}
					onChange={handleChange}
					type='text'
					styles={[styleSheet.questionInput]}
					inputId={inputId}
					value={value}
					disabled={disabled}
				/>
				{errorMessage ? <FormFieldErrorMessage errorMessage={errorMessage} /> : null}
			</div>
		);
	}
);

FieldInput.displayName = 'FieldInput';
